<template>
  <div class="dingqian-home">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="container">
        <!-- Logo 文字：DQ + 鼎乾招投标 -->
        <div class="logo-box">
          <div class="logo-dq">DQ</div>
          <div class="logo-text">鼎乾招投标</div>
        </div>
        <!-- 导航菜单 -->
        <ul class="nav-list">
          <li><a href="#">首页</a></li>
          <li><a href="#" @click="goNotice">招标公告</a></li>
          <li><a href="#" class="active">中标公示</a></li>
          <li><a href="#">政策法规</a></li>
          <li><a href="#">办事指南</a></li>
          <li><a href="#">关于我们</a></li>
        </ul>
      </div>
    </header>
    <!-- 搜索栏 -->
    <div class="search-bar">
      <div class="container">
        <input v-model="keywords" type="text" placeholder="请输入项目名称、公告类型搜索..." class="search-input" />
        <button class="search-btn">搜索</button>
      </div>
    </div>
    <!-- 主体内容 -->
    <div class="container main">
      <!-- 左侧公告 -->
      <div class="left">
        <!-- 最新公告（替换为中标结果公示内容，样式保持不变） -->
        <div class="card">
          <div class="card-header">
            <h3>最新公告</h3>
            <a href="#">更多 ></a>
          </div>
          <div class="notice-detail">
            <div class="notice-date">2026-06-09</div>
            <h2 class="notice-title">通富智能产业园六期项目主体工程中标候选人公示（暨中标结果公示）</h2>

            <div class="section">
              <p class="content-normal"><span class="label">招标编号：</span>E3502130201199943005</p>
              <p class="content-normal">本项目于2026年06月09日08:30分举行开标，经评标委员会评审，并报招标人确定中标人，现公示如下：</p>
            </div>

            <div class="section">
              <h3 class="section-title">一、招标基本情况</h3>
              <p class="content-normal"><span class="label">招标人：</span>厦门通富微电子有限公司</p>
              <p class="content-normal"><span class="label">招标人联系地址：</span>厦门市翔安区内厝镇舫山北二路 1108 号 1091室</p>
              <p class="content-normal"><span class="label">项目名称：</span>通富智能产业园六期项目主体工程</p>
            </div>

            <div class="section">
              <h3 class="section-title">二、开标情况</h3>
              <p class="content-highlight"><span class="label">招标控制价：</span><span class="price">346647867元</span></p>
              <p class="content-normal"><span class="label">抽取的K值：</span>7.02%</p>
              <p class="content-highlight"><span class="label">评标基准价：</span><span class="price">321001203元</span></p>
            </div>

            <div class="section">
              <h3 class="section-title">三、评标基本情况</h3>
              <p class="content-normal">1.入围评审合格的投标人排序情况如下：</p>

              <!-- 投标单位表格 -->
              <div style="margin:15px 0;overflow-x:auto;">
                <table border="1" cellpadding="8" cellspacing="0" style="width:100%;min-width:900px;border-collapse:collapse;text-align:center;">
                  <thead>
                  <tr style="background:#f8f9fb;">
                    <th style="border:1px solid #ccc;">序号</th>
                    <th style="border:1px solid #ccc;">入围评审的投标人名称</th>
                    <th style="border:1px solid #ccc;">投标报价（元）</th>
                    <th style="border:1px solid #ccc;">工期（日历天）</th>
                    <th style="border:1px solid #ccc;">质量标准</th>
                    <th style="border:1px solid #ccc;">项目负责人</th>
                    <th style="border:1px solid #ccc;">注册编号</th>
                    <th style="border:1px solid #ccc;">排序</th>
                    <th style="border:1px solid #ccc;">备注</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td style="border:1px solid #ccc;">1</td>
                    <td style="border:1px solid #ccc;">中铁八局集团第三工程有限公司</td>
                    <td style="border:1px solid #ccc;">322382516.3</td>
                    <td style="border:1px solid #ccc;">720</td>
                    <td style="border:1px solid #ccc;">合格</td>
                    <td style="border:1px solid #ccc;">李奕霖</td>
                    <td style="border:1px solid #ccc;">贵1352023202400358</td>
                    <td style="border:1px solid #ccc;">1</td>
                    <td style="border:1px solid #ccc;"></td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #ccc;">2</td>
                    <td style="border:1px solid #ccc;">福建省东岱建工集团有限公司</td>
                    <td style="border:1px solid #ccc;">322912341.5</td>
                    <td style="border:1px solid #ccc;">720</td>
                    <td style="border:1px solid #ccc;">合格</td>
                    <td style="border:1px solid #ccc;">金勇</td>
                    <td style="border:1px solid #ccc;">闽1332019202106270</td>
                    <td style="border:1px solid #ccc;">2</td>
                    <td style="border:1px solid #ccc;"></td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #ccc;">3</td>
                    <td style="border:1px solid #ccc;">福建九尚建设工程有限公司</td>
                    <td style="border:1px solid #ccc;">323032146.1</td>
                    <td style="border:1px solid #ccc;">720</td>
                    <td style="border:1px solid #ccc;">合格</td>
                    <td style="border:1px solid #ccc;">林子泱</td>
                    <td style="border:1px solid #ccc;">闽1352019202001062</td>
                    <td style="border:1px solid #ccc;">3</td>
                    <td style="border:1px solid #ccc;"></td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #ccc;">4</td>
                    <td style="border:1px solid #ccc;">安徽建工三建集团有限公司</td>
                    <td style="border:1px solid #ccc;">326541239.8</td>
                    <td style="border:1px solid #ccc;">720</td>
                    <td style="border:1px solid #ccc;">合格</td>
                    <td style="border:1px solid #ccc;">张燕</td>
                    <td style="border:1px solid #ccc;">皖1342010201005486</td>
                    <td style="border:1px solid #ccc;">4</td>
                    <td style="border:1px solid #ccc;"></td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #ccc;">5</td>
                    <td style="border:1px solid #ccc;">隆恩建设工程有限公司</td>
                    <td style="border:1px solid #ccc;">331456121.5</td>
                    <td style="border:1px solid #ccc;">720</td>
                    <td style="border:1px solid #ccc;">合格</td>
                    <td style="border:1px solid #ccc;">苏俊超</td>
                    <td style="border:1px solid #ccc;">闽1352020202103049</td>
                    <td style="border:1px solid #ccc;">5</td>
                    <td style="border:1px solid #ccc;"></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <p class="content-normal" style="margin-top:16px;">2.推荐的中标候选人：</p>
              <p class="content-normal">评标委员会根据招标文件既定的评标办法，对有关投标人的投标文件进行评审，推荐的中标候选人：
                <span class="text-blue">中铁八局集团第三工程有限公司</span>，投标报价：<span class="price">322382516.3元</span>，
                工期：总工期为<span class="date-red">720个日历天</span>，质量要求：符合国家现行《工程施工质量验收规范》合格标准，
                项目负责人：<span class="text-blue">李奕霖</span>，注册证书编号：<span class="text-blue">贵1352023202400358</span>。
              </p>
            </div>

            <div class="section">
              <h3 class="section-title">四、公示时间</h3>
              <p class="content-normal"><span class="text-red">2026年06月09日至2026年06月12日</span></p>
            </div>

            <div class="section">
              <h3 class="section-title">五、异议的渠道和方式</h3>
              <p class="content-normal">各投标人如有异议，请于公示期内以书面形式（投诉材料应由法定代表人签字或盖章并加盖单位公章，同时注明投诉人的联系电话、地址、邮政编码、联系人）向招标人提出异议。公示期满后，若未收到投标人投诉，招标单位（招标代理单位）将按规定发放中标通知书。</p>
            </div>

            <div class="notice-sign">
              招标人：厦门通富微电子有限公司<br>
              招标代理机构：北京建友工程造价咨询有限公司<br>
              日期：2026年06月09日
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right">
        <!-- 招标文件下载卡片 - 美化版 -->
        <div class="card download-card">
          <div class="card-header">
            <h3>
              <i class="icon-download"></i> 招标文件下载
            </h3>
          </div>
          <div class="download-content">
            <div class="file-info">
              <div class="file-icon">📄</div>
              <div class="file-name">通富智能产业园六期项目主体工程 招标公告</div>
            </div>
            <!-- 下载按钮 -->
            <a class="download-btn" @click="downloadLocalFile">
              <span class="btn-text">立即下载</span>
              <span class="btn-icon">↓</span>
            </a>
          </div>
        </div>
        <div class="card">
          <div class="card-header"><h3>项目分类</h3></div>
          <div class="category-list">
            <div class="cat-item">工程建设</div>
            <div class="cat-item">政府采购</div>
            <div class="cat-item">设备采购</div>
            <div class="cat-item">服务类</div>
            <div class="cat-item">园林景观</div>
            <div class="cat-item">市政工程</div>
          </div>
        </div>
        <div class="card">
          <div class="card-header"><h3>快捷入口</h3></div>
          <div class="quick-list">
            <div class="quick-item">我要招标</div>
            <div class="quick-item">我要投标</div>
            <div class="quick-item">公告查询</div>
            <div class="quick-item">投诉监督</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <footer class="footer">
      <div class="container">
        <p>鼎乾招投标服务平台 © 2026 版权所有</p>
        <p>规范 透明 诚信 共赢</p>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "zbResultNotice",
  data() {
    return {
      keywords: ''
    };
  },
  methods: {
    goNotice() {
      this.$router.push("/");
    },
    downloadLocalFile() {
      const url = "/files/tfzn.doc"; // 路径对应 public/files/xxx
      const link = document.createElement("a");
      link.href = url;
      link.download = "通富智能产业园六期项目主体工程招标正文.doc";
      link.click();
    }
  }
};
</script>
<style scoped>
/* 全局 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  background: #f5f7fa;
  font-family: "Microsoft YaHei", sans-serif;
}
a {
  text-decoration: none;
  color: inherit;
}
li {
  list-style: none;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
/* 头部 */
.header {
  background: #0f469b;
  color: #fff;
  padding: 18px 0;
}
.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-box {
  display: flex;
  align-items: center;
  gap: 12px;
}
.logo-dq {
  font-size: 28px;
  font-weight: bold;
  background: #ffc107;
  color: #0f469b;
  width: 50px;
  height: 50px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-text {
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 1px;
}
.nav-list {
  display: flex;
  font-size: 16px;
}
.nav-list li {
  margin-left: 32px;
}
.nav-list a.active,
.nav-list a:hover {
  color: #ffc107;
  border-bottom: 2px solid #ffc107;
}
/* 搜索框 */
.search-bar {
  background: #fff;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
.search-bar .container {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.search-input {
  width: 600px;
  height: 44px;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0 15px;
  font-size: 14px;
  outline: none;
}
.search-btn {
  height: 44px;
  padding: 0 28px;
  background: #0f469b;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
/* 主体布局 */
.main {
  display: flex;
  gap: 20px;
  margin: 30px auto;
}
.left { flex: 3; }
.right { flex: 1; }
/* 卡片 */
.card {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}
.card-header {
  padding: 15px 20px;
  background: #f8f9fb;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-header h3 {
  color: #0f469b;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}
/* 公告字体大小 + 颜色美化 */
.notice-detail { padding: 35px; }
.notice-date { font-size: 15px; color: #666; margin-bottom: 10px; }
.notice-title {
  font-size: 26px;
  color: #0f469b;
  margin-bottom: 30px;
  font-weight: bold;
  cursor: pointer;
}
.section { margin-bottom: 30px; }
.section-title {
  font-size: 20px;
  color: #c0392b;
  margin-bottom: 15px;
  font-weight: bold;
  border-left: 4px solid #c0392b;
  padding-left: 10px;
}
/* 正文字体大小分级 */
.content-normal {
  font-size: 16px;
  color: #333;
  line-height: 2;
  margin-bottom: 8px;
}
.content-highlight {
  font-size: 17px;
  color: #222;
  line-height: 2;
  font-weight: 500;
}
.content-contact {
  font-size: 15px;
  color: #2980b9;
  line-height: 2;
}
/* 标签样式 */
.label {
  font-weight: bold;
  color: #0f469b;
}
/* 高亮颜色 */
.price { color: #e74c3c; font-weight: bold; font-size: 17px; }
.text-red { color: #e74c3c; font-weight: bold; }
.text-blue { color: #2980b9; font-weight: bold; }
.date-red { color: #c0392b; font-weight: bold; }
/* 蓝色超链接样式 */
.link-blue {
  color: #0f469b !important;
  text-decoration: underline !important;
  font-weight: 500;
}
.link-blue:hover {
  color: #1a6cef !important;
}
/* 落款 */
.notice-sign {
  margin-top: 40px;
  text-align: right;
  font-size: 16px;
  color: #333;
  line-height: 2;
  font-weight: 500;
}
/* 列表 */
.notice-list { padding: 15px 20px; }
.notice-list li {
  padding: 10px 0;
  border-bottom: 1px dashed #eee;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
/* 分类 */
.category-list {
  padding: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.cat-item {
  background: #f2f7ff;
  color: #0f469b;
  text-align: center;
  padding: 12px 0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.cat-item:hover { background: #0f469b; color: #fff; }
/* 快捷入口 */
.quick-list { padding: 15px; }
.quick-item {
  background: #0f469b;
  color: #fff;
  text-align: center;
  padding: 14px 0;
  border-radius: 6px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.quick-item:hover {
  background: #1a6cef;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(15, 70, 155, 0.2);
}
/* 底部 */
.footer {
  background: #222;
  color: #ccc;
  text-align: center;
  padding: 30px 0;
}
/* 下载卡片 美化样式 */
.download-card {
  border: 1px solid #e8f4ff;
}
.download-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #eee;
}
.file-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8f4ff;
  border-radius: 8px;
}
.file-name {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  flex: 1;
}
.download-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 0;
  background: linear-gradient(135deg, #0f469b 0%, #1a6cef 100%);
  color: #fff !important;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(15, 70, 155, 0.1);
}
.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(15, 70, 155, 0.2);
  background: linear-gradient(135deg, #1a6cef 0%, #2580f7 100%);
}
.download-btn .btn-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
}
.download-btn:hover .btn-icon {
  transform: translateY(2px);
}
.download-tips {
  font-size: 12px;
  color: #999;
  text-align: center;
  padding-top: 5px;
}
</style>